import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import * as API from "../../utils/api.service";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import SubNavbar from "../../layout/SubNavbar";
import { setLoader } from "../../Store/slices/MasterSlice";
import {
  getSubscriptionApiCall,
  editSubscriptionApiCall,
} from "../../Store/slices/subscriptionSlice";

import {
  TOAST_ERROR,
  SWIT_SUCCESS,
  TEXT_WITH_NOT_START_SPACE_VALIDATION,
  NUMBER_VALIDATION,
} from "../../utils/common.service";
import { IoMdArrowRoundBack } from "react-icons/io";

export default function AddChallenge() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  // Check if subscriptionData is passed in location state for editing
  const subscriptionData = location.state?.subscriptionData;

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control,
    setValue,
    clearErrors,
  } = useForm();

  // Populate the form with default values when editing
  useEffect(() => {
    if (subscriptionData) {
      setValue("name", subscriptionData.name);
      setValue("name_arabic", subscriptionData.name_ar);
      setValue("description", subscriptionData.description);
      setValue("description_arabic", subscriptionData.ar_description);
      setValue("max_students", subscriptionData.max_student);
      setValue("price", subscriptionData.price);
      setValue("duration", subscriptionData.validity_days);
      setValue("free_trial_days", subscriptionData.free_trial_days);
    }
  }, [subscriptionData, setValue]);

  // Handle form submission
  const onSubmit = async (submitData) => {
    try {
      dispatch(setLoader(true));

      const {
        name,
        name_arabic,
        description,
        description_arabic,
        max_students,
        price,
        duration,
        free_trial_days,
      } = submitData;

      const requestBody = {
        name: name,
        name_ar: name_arabic,
        description: description,
        ar_description: description_arabic,
        max_student: max_students,
        free_trial_days,
        price,
        validity_days: duration,
        subscription_type: "school",
      };

      const updateBody = {
        id: subscriptionData ? subscriptionData.id : undefined,
        product_id: subscriptionData ? subscriptionData.product_id : undefined,
        plan_id: subscriptionData ? subscriptionData.plan_id : undefined,
        name: name,
        name_ar: name_arabic,
        description: description,
        ar_description: description_arabic,
        max_student: max_students,
        // free_trial_days,
        // price,
        // validity_days: duration,
        subscription_type: "school",
      };

      if (subscriptionData) {
        // Update existing subscription
        await dispatch(editSubscriptionApiCall(updateBody));
        navigate(`/manage_subscription`);
        reset();
      } else {
        // Create new subscription
        const { code, message } = await API.insertSubscriptionApi(requestBody);

        if (code === "1") {
          SWIT_SUCCESS(message);
          navigate(`/manage_subscription`);
          reset();
        }

        dispatch(setLoader(false));
      }
    } catch (err) {
      TOAST_ERROR(err.message);
      dispatch(setLoader(false));
    }
  };

  return (
    <>
      <div className="content">
        <div className="container-fluid">
          <SubNavbar
            title={subscriptionData ? "Edit Subscription" : "Add Subscription"}
            header="Subscription"
            subHeader={
              subscriptionData ? "Edit Subscription" : "Add Subscription"
            }
          />
          <div className="card rounded-3">
            <div className="card-body">
              <div className="d-flex justify-content-lg-start">
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => navigate(-1)}
                >
                  <IoMdArrowRoundBack fontSize={"20px"} />
                </button>
              </div>
              <form onSubmit={handleSubmit(onSubmit)}>
                {/* Plane Name */}
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label htmlFor="user_name" className="form-label">
                      Plane Name
                    </label>
                    <input
                      type="text"
                      id="user_name"
                      className="form-control"
                      placeholder="Enter Plane Name"
                      {...register(
                        "name",
                        TEXT_WITH_NOT_START_SPACE_VALIDATION("plane name")
                      )}
                    />
                    <div className="errorc">{errors.user_name?.message}</div>
                  </div>

                  <div className="col-md-6">
                    <label htmlFor="name_ar" className="form-label">
                      Plane Name in Arabic
                    </label>
                    <input
                      type="text"
                      id="name_arabic"
                      className="form-control"
                      placeholder="Enter Plane Name in Arabic"
                      {...register(
                        "name_arabic",
                        TEXT_WITH_NOT_START_SPACE_VALIDATION("name_arabic")
                      )}
                    />
                    <div className="errorc">{errors.name_arabic?.message}</div>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-3">
                    <label htmlFor="max_students" className="form-label">
                      Maximum Students
                    </label>
                    <input
                      type="number"
                      id="max_students"
                      className="form-control"
                      placeholder="Enter Maximum Students"
                      {...register(
                        "max_students",
                        NUMBER_VALIDATION("max_students")
                      )}
                    />
                    <div className="errorc">{errors.max_students?.message}</div>
                  </div>
                  {!subscriptionData && (
                    <>
                      <div className="col-md-3">
                        <label htmlFor="price" className="form-label">
                          Price
                        </label>
                        <input
                          type="number"
                          id="price"
                          className="form-control"
                          placeholder="Enter Price"
                          {...register("price", NUMBER_VALIDATION("price"))}
                        />
                        <div className="errorc">{errors.price?.message}</div>
                      </div>
                      <div className="col-md-3">
                        <label htmlFor="duration" className="form-label">
                          Duration (in days)
                        </label>
                        <input
                          type="number"
                          id="duration"
                          className="form-control"
                          placeholder="Enter Duration"
                          {...register(
                            "duration",
                            NUMBER_VALIDATION("duration")
                          )}
                        />
                        <div className="errorc">{errors.duration?.message}</div>
                      </div>

                      <div className="col-md-3">
                        <label htmlFor="free_trial_days" className="form-label">
                          Free Trial (in days)
                        </label>
                        <input
                          type="number"
                          id="free_trial_days"
                          className="form-control"
                          placeholder="Enter Free Trial Duration"
                          {...register(
                            "free_trial_days",
                            NUMBER_VALIDATION("Free Trial")
                          )}
                        />
                        <div className="errorc">
                          {errors.free_trial_days?.message}
                        </div>
                      </div>
                    </>
                  )}
                </div>

                {/* Description */}
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label htmlFor="description" className="form-label">
                      Description
                    </label>
                    <textarea
                      className="form-control"
                      id="description"
                      rows="3"
                      {...register("description", {
                        maxLength: {
                          value: 127,
                          message: "Description cannot exceed 127 characters",
                        },
                      })}
                    />
                    <div className="errorc">{errors.description?.message}</div>
                  </div>
                </div>

                {/* Description in Arabic */}
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label htmlFor="description_arabic" className="form-label">
                      Description in Arabic
                    </label>
                    <textarea
                      className="form-control"
                      id="description_arabic"
                      rows="3"
                      {...register("description_arabic", {
                        maxLength: {
                          value: 127,
                          message:
                            "Description in Arabic cannot exceed 127 characters",
                        },
                      })}
                    />
                    <div className="errorc">
                      {errors.description_arabic?.message}
                    </div>
                  </div>
                </div>

                {/* Submit Button */}
                <div className="row">
                  <div className="col-md-12 text-center">
                    <button type="submit" className="btn btn-primary">
                      {subscriptionData ? "Update" : "Submit"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
